
import {
    USERSSCREEN_LOAD,
    USERSSCREEN_UNLOAD,
    USERSSCREEN_SET,
} from '../../../../actionDefinitions';

import {
    fetchUsersSummary,
    _createNewUser,
    _terminateUser,
    _activateUser,
    fetchTeamsSummary,
    fetchTeamsHierarchy,
    _updateUser,
} from '../../../../api/v3/AdminApi';

import {
    fetchDomainValues
} from '../../../../api/v3/DataApi';

export function loadUsersScreen() {
    return dispatch => {
        dispatch(loadUsersSummary());
        dispatch(loadAllTeams());
        dispatch(loadTeamsHierarchy());
        dispatch(loadDomainValues());
    };
}

export function loadDomainValues() {
    return dispatch =>
        fetchDomainValues()
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { domainValues: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function loadTeamsHierarchy() {
    return dispatch =>
        fetchTeamsHierarchy()
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { teamsHierarchy: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function loadAllTeams() {
    return dispatch =>
        fetchTeamsSummary()
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { allTeams: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function loadUsersSummary() {
    return dispatch =>
        fetchUsersSummary()
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { usersSummary: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: USERSSCREEN_SET, updatedProps });
    }
}

export function terminateUser(userId) {
    return dispatch =>
        _terminateUser(userId)
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { terminatedUserId: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function activateUser(userId) {
    return dispatch =>
        _activateUser(userId)
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { activatedUserId: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function createNewUser(newUser) {
    return dispatch =>
        _createNewUser(newUser)
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { newlyAddedUser: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

export function updateUser(userUpdateInfo) {
    return dispatch =>
        _updateUser(userUpdateInfo)
            .then(payload => dispatch({ type: USERSSCREEN_LOAD, payload: { newlyUpdatedUser: payload.result } }))
            .catch(payload => dispatch({ type: USERSSCREEN_LOAD, error: true, payload }))
}

